/* ===========================================================================
   Drag and drop elements
   =========================================================================== */

import {checkStepValidation} from "./step";

$( document ).ready(function() {
  function dragSort() {
    let recapImage = $('#js-imagePrimary');
    $('.sortable').dragsort({
      dragSelector: 'li',
      dragEnd: function() {
        let data = $(".sortable li").map(function (index) {
          let newIndex = index+1;
          if (newIndex === 1) {
            $(".sortable li").find('.js-primary-picture').removeClass('js-primary-picture');
            $(this).find("input[type='file']").prop('id', 'p2s_new_item_pictures_front');
            $(this).find("input[type='file']").prop('name', 'p2s_new_item[pictures][front]');
            $(this).find("input[type='file']").prop('required', 'required');
            $(this).find("input[type='file']").addClass('js-primary-picture');
            $(this).find("label").prop('for', 'p2s_new_item_pictures_front');
            $(this).find("header label").html('Photo de face');
            $(this).find("header a").data('open', 'modal-example-p2s_new_item_pictures_front');
            recapImage.prev('canvas').remove();
            recapImage.prop('src', $(this).find('img.js-file-image').prop('src'));
          }
          if (newIndex === 2) {
            $(this).find("input[type='file']").prop('id', 'p2s_new_item_pictures_back');
            $(this).find("input[type='file']").prop('name', 'p2s_new_item[pictures][back]');
            $(this).find("input[type='file']").prop('required', 'required');
            $(this).find("label").prop('for', 'p2s_new_item_pictures_back');
            $(this).find("header label").html('Photo de dos');
            $(this).find("header a").data('open', 'modal-example-p2s_new_item_pictures_back');
            /*$(this).find("button[type='button']").remove();
            $(this).find(".js-file-wording, .upload-file-wording").hide();*/
          }
          if (newIndex === 3) {
            $(this).find("input[type='file']").prop('id', 'p2s_new_item_optionalPictures_tradename');
            $(this).find("input[type='file']").prop('name', 'p2s_new_item[optionalPictures][tradename]');
            $(this).find("input[type='file']").prop('required', '');
            $(this).find("label").prop('for', 'p2s_new_item_optionalPictures_tradename');
            $(this).find("header label").html('Photo de la marque<small>(Facultatif)</small>');
            $(this).find("header a").data('open', 'modal-example-p2s_new_item_optionalPictures_tradename');
            /*$(this).append('<button type="button" title="Supprimer mon image" class="js-remove-file upload-file-button-remove cart-drop-button icon-close">Supprimer mon image</button>');
            $(this).find(".js-file-wording, .upload-file-wording").show();*/
          }
          if (newIndex === 4) {
            $(this).find("input[type='file']").prop('id', 'p2s_new_item_optionalPictures_additional');
            $(this).find("input[type='file']").prop('name', 'p2s_new_item[optionalPictures][additional]');
            $(this).find("input[type='file']").prop('required', '');
            $(this).find("label").prop('for', 'p2s_new_item_optionalPictures_additional');
            $(this).find("header label").html('Autre photo<small>(Facultatif)</small>');
            $(this).find("header a").data('open', 'modal-example-p2s_new_item_optionalPictures_additional');
            $(this).find("header label small").removeClass('is-invisible');
            /*$(this).append('<button type="button" title="Supprimer mon image" class="js-remove-file upload-file-button-remove cart-drop-button icon-close">Supprimer mon image</button>');
            $(this).find(".js-file-wording, .upload-file-wording").show();*/
          }
          if (newIndex === 5) {
            $(this).find("input[type='file']").prop('id', 'p2s_new_item_optionalPictures_additional2');
            $(this).find("input[type='file']").prop('name', 'p2s_new_item[optionalPictures][additional2]');
            $(this).find("input[type='file']").prop('required', '');
            $(this).find("label").prop('for', 'p2s_new_item_optionalPictures_additional2');
            $(this).find("header label").html('Autre photo<small>(Facultatif)</small>');
            $(this).find("header a").data('open', 'modal-example-p2s_new_item_optionalPictures_additional2');
            $(this).find("header label small").removeClass('is-invisible');
            /*$(this).append('<button type="button" title="Supprimer mon image" class="js-remove-file upload-file-button-remove cart-drop-button icon-close">Supprimer mon image</button>');
            $(this).find(".js-file-wording, .upload-file-wording").show();*/
          }
          checkStepValidation($(this));
        });
      },
      dragBetween: false,
      cursor: "move",
      placeHolderTemplate: '<li></li>'
    });
  }

  function dragSortDestroy() {
    $('.sortable').dragsort('destroy');
  }

  let windowSize = $(window).width();

  // Desktop only, initially launched
  // large: 1024px
  if (windowSize > 1023){
    dragSort();
  } else {
    dragSortDestroy();
  }

  $(window).resize(function() {
    let windowSize = $(window).width();

    // On desktop, launched on resize
    if (windowSize > 1023){
      dragSort();
    } else {
      dragSortDestroy();
    }
  });

});
